import ButtonDiagram from "../../../../docs/_images/hw_ff_button.png";
import ButtonSchematics from "../../../../docs/_images/hw_ff_button_schem.png";
import HwButton from "../../../../docs/_images/hw_button.jpg";
import * as React from 'react';
export default {
  ButtonDiagram,
  ButtonSchematics,
  HwButton,
  React
};